import { Route } from "react-router-dom";
import AdvertListIndex from "./ListItems/RealStateListIndex";
import ProductDetails from 'apps/RealState/Details/ProductDetails';









export const realStateRouteList = [
  <Route key={"realStateRouteList"}>
     <Route path="/:slug/detay"  element={<ProductDetails />}  />
     <Route path="/ilan/:categoryUrl/*"   element={<AdvertListIndex/>}/>
     <Route path="/ilan" element={<AdvertListIndex/>}/>
   
  </Route>,
];
